import React from "react";
import { TableHead, TableRow, TableCell } from "@mui/material";
import { MdArrowDownward, MdArrowUpward, MdUnfoldMore } from "react-icons/md";

const ProfitTableHeader = ({ amountSort = 'default', onAmountSortChange, profitColumnTitle = 'Senior Master Profit' }) => {
  const SortIcon = amountSort === 'asc'
    ? MdArrowUpward
    : amountSort === 'desc'
      ? MdArrowDownward
      : MdUnfoldMore;

  const handleAmountSortClick = () => {
    const nextSort = amountSort === 'default' ? 'asc' : amountSort === 'asc' ? 'desc' : 'default';
    onAmountSortChange?.(nextSort);
  };

  return (
    <TableHead style={{ border: '1px solid white' }}>
      <TableRow className="bg-background dark:bg-custom_dark_primary2">
        <TableCell rowSpan={2}>
          <span className="text-white font-semibold">No</span>
        </TableCell>
        <TableCell rowSpan={2}>
          <span className="text-white font-semibold">User Id</span>
        </TableCell>
        <TableCell rowSpan={2}>
          <span className="text-white font-semibold">Name</span>
        </TableCell>
        <TableCell rowSpan={2}>
          <button
            type="button"
            className="flex items-center gap-1 text-white font-semibold hover:text-customLightYellow"
            onClick={handleAmountSortClick}
            title="Sort by amount"
            aria-label="Sort by amount"
          >
            <span>Amount</span>
            <SortIcon className="text-base" />
          </button>
        </TableCell>
        <TableCell rowSpan={2}>
          <span className="text-white font-semibold">Type</span>
        </TableCell>
        <TableCell colSpan={3} align="center">
          <span className="text-white font-bold">Member Profit</span>
        </TableCell>
        <TableCell colSpan={3} align="center">
          <span className="text-white font-bold">{profitColumnTitle}</span>
        </TableCell>
        <TableCell colSpan={3} align="center">
          <span className="text-white font-bold">Company Profit</span>
        </TableCell>
      </TableRow>

      <TableRow className="bg-background dark:bg-custom_dark_primary2">
        {['WL', 'Com', 'WL+Com', 'WL', 'Com', 'WL+Com', 'WL', 'Com', 'WL+Com'].map(
          (label, index) => (
            <TableCell
              key={index}
              align="center"
              className="font-semibold text-gray-700 text-sm"
            >
              <span className="text-white font-semibold">{label}</span>
            </TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
};

export default ProfitTableHeader;
